import Style from './FJClose.module.less';
import CloseIcon from '../../../assets/svg/modal-close.svg?react';
import classNames from 'classnames';

const FJClose = props => {
    return (
        <div className={classNames(Style.close, props.className)} onClick={props.onClick} style={props.style}>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: 16,
                    background: 'rgba(255,255,255,0.15)',
                }}
            >
                <CloseIcon />
            </div>
        </div>
    );
};

export default FJClose;
